import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { groupCampaignsByProvider } from '../../RightCampaigns/helpers'

import {
  combinedCampaignsSelector,
  combinedCampaignsWasLoadedSelector
} from '../../../../../modules/selectors/combinedData'
import { clearCombinedLineItems, getCombinedLineItems } from '../../../../../modules/actions/combinedData'
import { rightSelector } from '../../../../../modules/selectors/rights'

const insights = [
  'impressions',
  'cpm',
  'cpa',
  'reach',
  'frequency',
  'clicks',
  'ctr',
  'conversions',
  'engagement',
  'results'
]

export const useGetCombinedLineItems = () => {
  const dispatch = useDispatch()

  const { campaigns: rightCampaignsToLoad } = useSelector(rightSelector)
  const { campaigns_date_range: campaignsDateRange, campaigns = [] } = useSelector(combinedCampaignsSelector)
  const combinedCampaignsWasLoaded = useSelector(combinedCampaignsWasLoadedSelector)

  const someCombinedCampaignsHasError = useMemo(() => campaigns.some(campaign => campaign.error), [campaigns])
  const { date_from, date_to } = campaignsDateRange || {}

  const campaignsGroupedByProvider = useMemo(
    () => groupCampaignsByProvider(rightCampaignsToLoad),
    [rightCampaignsToLoad]
  )

  useEffect(() => {
    if (
      // Don't fetch lineItems before campaigns are loaded
      combinedCampaignsWasLoaded &&
      // Check if there are no errors in combined campaigns, otherwise no need to fetch lineItems, because they are not valid anyway
      !someCombinedCampaignsHasError &&
      date_from &&
      date_to
    ) {
      dispatch(
        getCombinedLineItems({
          insights,
          date_from,
          date_to,
          providers: campaignsGroupedByProvider
        })
      )
    }
  }, [
    dispatch,
    campaignsGroupedByProvider,
    combinedCampaignsWasLoaded,
    date_from,
    date_to,
    someCombinedCampaignsHasError
  ])

  useEffect(() => {
    return () => {
      dispatch(clearCombinedLineItems())
    }
  }, [dispatch])
}
